import React from 'react';

import { Button } from 'primereact/button';

import CustomDropdown from '../CustomDropdown';
import CustomInputNumber from '../CustomInputNumber';

import './style.css';

interface INoTotalPaginator {
    page: number;
    rows: number;
    rowsPerPageOptions: number[];
    onPageChange(event: { page: number; rows: number }): void;
    disableNext?: boolean;
    style?: React.CSSProperties;
}

const NoTotalPaginator: React.FC<INoTotalPaginator> = ({
    page,
    rows,
    onPageChange,
    rowsPerPageOptions = [5, 10, 50],
    disableNext,
    style,
}) => {
    return (
        <div className='no-total-paginator-wrap' style={style}>
            <div className='page-buttons'>
                <span className='p-buttonset'>
                    <Button
                        icon='pi pi-angle-double-left'
                        disabled={page === 1}
                        onClick={() => onPageChange({ page: 1, rows })}
                    />
                    <Button
                        label='Prev.'
                        icon='pi pi-angle-left'
                        disabled={page === 1}
                        onClick={() => onPageChange({ page: page - 1, rows })}
                    />
                    <CustomInputNumber
                        format={false}
                        value={page}
                        inputStyle={{ borderRadius: 0, margin: '0 1px 0 1px' }}
                        onValueChange={(e) =>
                            onPageChange({
                                page:
                                    e.target.value == null ? 1 : e.target.value,
                                rows,
                            })
                        }
                        labelStyle={{ fontSize: '14px' }}
                        size={1}
                        min={1}
                    />
                    <Button
                        label='Next'
                        icon='pi pi-angle-right'
                        iconPos='right'
                        disabled={disableNext}
                        onClick={() => onPageChange({ page: page + 1, rows })}
                        style={{ marginRight: '8px' }}
                    />
                </span>
            </div>
            <CustomDropdown
                value={rows}
                options={rowsPerPageOptions}
                onChange={(e) => onPageChange({ page, rows: e.value })}
            />
        </div>
    );
};

export default NoTotalPaginator;
